import { render } from "./SupplierValidationTab.vue?vue&type=template&id=2fc8418c"
import script from "./SupplierValidationTab.vue?vue&type=script&lang=js"
export * from "./SupplierValidationTab.vue?vue&type=script&lang=js"

import "./SupplierValidationTab.vue?vue&type=style&index=0&id=2fc8418c&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__